export const observableFromService = <A>(
  service: (args: A) => Promise<{ error?: { data: unknown }; data: unknown }>,
  args: A,
) =>
  service(args).then(result => {
    if (result.error) {
      throw result.error.data;
    }
    return result.data;
  });
